import { jsxs as e, jsx as n } from "react/jsx-runtime";
import "react";
import { InstructionsList as t } from "../InstructionsList/InstructionsList.js";
import '../../assets/RescanInstructions.css';const s = "_rescan__header_ndzy9_5", o = {
  "rescan-instructions": "_rescan-instructions_ndzy9_1",
  rescan__header: s
};
function g({ brandName: r = "" }) {
  return /* @__PURE__ */ e("section", { className: [o["rescan-instructions"], "rescan-instructions"].join(" "), children: [
    /* @__PURE__ */ n("h3", { className: [o.rescan__header, "rescan__header"].join(" "), children: "LEARN HOW TO RESCAN" }),
    /* @__PURE__ */ n(t, { instructions: [
      "Press the <strong>Menu</strong> button on your Converter Box, Digital TV, or remote.",
      "Go to <strong>Setup</strong> or <strong>Settings</strong>.",
      "Go to <strong>Installation</strong>, or <strong>System</strong>, or <strong>Channels</strong>.",
      "Go to <strong>Scan Channels</strong>, or <strong>Program Channels</strong>, or <strong>Auto Scan</strong>, or <strong>Auto Program</strong>, or <strong>Auto-Tuning</strong>.",
      "Press <strong>Select</strong>, or <strong>Enter</strong>, or <strong>OK</strong> to scan."
    ], headerHtml: `Watching ${r} with an antenna? You may need to rescan your TV.` }),
    /* @__PURE__ */ n(t, { instructions: [
      "Disconnect the antenna from the Digital TV or Converter Box.",
      "Rescan without the antenna connected. As with any scan, follow the on-screen instructions or owner's manual for your device.",
      "Unplug the Digital TV or Converter Box from the electrical outlet for one minute.",
      "Reconnect the antenna to the Digital TV or Converter Box and plug the unit into the electrical outlet.",
      "Rescan the Digital TV or Converter Box one more time."
    ], headerHtml: "Sometimes, a double rescan is needed to clear the memory of your Digital TV or Converter Box:" })
  ] });
}
export {
  g as RescanInstructions,
  g as default
};
